/**
 * @fileoverview provide / inject で受け渡す値のキー
 * @description 文字列リテラルを provide 側と inject 側に直書きすると、タイポしても
 *              型エラーにも実行時エラーにもならず、inject 側が既定値にフォールバックして
 *              静かに挙動が変わる。型付きの InjectionKey を経由させることで
 *              不一致をコンパイルエラーにする
 * @description entrypoint の app.provide('EXTERNAL_URL', ...) 等は全ページへ配る定数群で
 *              所有者が不在なため文字列キーのままにしている。ここに置くのは、
 *              受け渡す側と受け取る側が特定できる値のみ
 */
import type { InjectionKey } from 'vue'

/**
 * プレビュー表示かどうか
 * @description provide 元はプレビューのページコンポーネント（pages/preview 配下の App.vue）、
 *              inject 先は components/_core/TemplateSolutionFormLp.vue。
 *              公開ページでは provide されないため既定の false になる
 */
export const IS_PREVIEW: InjectionKey<boolean> = Symbol('IS_PREVIEW')
